/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import Header from '../../components/header';
import Footer from '../../components/footer';
import stepImg1 from '../../assets/step1.png';
import stepImg2 from '../../assets/step2.png';
import stepImg3 from '../../assets/step3.png';
import stepImg4 from '../../assets/step4.png';
import stepImg5 from '../../assets/step5.png';
import stepImg6 from '../../assets/step6.png';
import stepImg7 from '../../assets/step7.png';
import stepImg8 from '../../assets/step8.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

export default function A1() {
  const history = useHistory();

  const [step, setStep] = useState(1);

  function handleInit(e) {
    e.preventDefault();
    history.push('/options');
  }

  return (
    <>
      <Header content="Tutorial Instalação A1" />
      <div className="tutorial-container container-md">
        <div className="tutorial-content">
          <div className="row">
            <div
              className="tutorial-step"
              style={{ display: step === 1 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6">
                  <img src={stepImg1} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1 </h1>
                  <p>
                    <a
                      href="https://ar-icp-brasil.validcertificadora.com.br/ra-endEntity-web/pages/private/certificate/findcertificaterequest.jsf?skin=SKV000113&faces-redirect=true"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: 'black' }}
                    >
                      Clique aqui para acessar o link de instalação do
                      certificado. Após clicar, avance para o próximo passo.
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 2 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg1} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2 </h1>
                  <p>
                    Digite o ticket e a senha do seu certificado e os caracteres
                    da caixa.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 3 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg2} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 3 </h1>
                  <p>
                    Aguarde um momento até que o texto "MICROSOFT ENHANCED..."
                    apareça na tela. Após aparecer, marque as duas caixas e
                    clique em "INSTALAR". Feito isso uma nova janela irá surgir
                    e você deverá clicar em "INICIAR"
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 4 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg4} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 4 </h1>
                  <p>
                    Quando uma caixa surgir na tela informando que o certificado
                    está sendo emitido, procure na barra de navegação um novo
                    ícone como na imagem ao lado.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 5 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg4} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 5 </h1>
                  <p>
                    Digite a senha do certificado e clique no botão "OK" assim
                    que terminar de digitar. Esse processo deverá ser feito duas
                    vezes por motivos de segurança e confirmação da senha.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 6 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg5} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 6 </h1>
                  <p>
                    Caso o processo ocorra com sucesso, uma mensagem irá
                    informa-lo disso e uma nova janela surgirá na tela mostrando
                    o arquivo do certificado salvo. Os dois destinos mais comuns
                    são a área de trabalho(desktop) ou documentos.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 7 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg6} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 7 </h1>
                  <p>
                    Com o arquivo do certificado gerado devemos fazer a
                    importação dele para o repositório do Windows. Clique duas
                    vezes no arquivo que terá o nome da empresa mais cnpj e com
                    o final ".pfx".
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 8 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg7} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 8 </h1>
                  <p>
                    Essa parte é bem simples: clique em avançar até ser
                    solicitado pelo inportador a senha do certificado. Nessa
                    etapa é de suma importância que selecione a segunda caixinha
                    além de deixar a terceira também marcada. Com essas opções,
                    caso você perca o arquivo, gerado no processo anterior, você
                    conseguirá gerar um novo a partir do seu computador. Depois
                    disso, clique em avançar até o final novamente.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 9 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg8} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 9 </h1>
                  <p>
                    Após obter a mensagem "A importação obteve êxito" o seu
                    certificado está pronto para ser utilizado. Recomendamos
                    também que o salve em um outro local como a nuvem, pendrive
                    ou e-mail. Se o processo obteve algum erro e não queira
                    tentar novamente, clique no botão abaixo "Suporte Técnico" e
                    siga as instruções para entrar em contato conosco.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row ">
          <div className="col-12">
            <div className="row justify-content-between ml-3 mr-3">
              <div>
                {step >= 2 ? (
                  <button
                    type="submit"
                    className="btn btn-info m-1 btn-tutorial"
                    onClick={() => setStep(step - 1)}
                  >
                    Voltar
                  </button>
                ) : (
                  ''
                )}
              </div>

              {step >= 1 && step <= 8 ? (
                <button
                  type="submit"
                  className="btn btn-info m-1 btn-tutorial"
                  onClick={() => setStep(step + 1)}
                >
                  Avançar
                </button>
              ) : (
                ''
              )}

              {step === 9 ? (
                <button type="submit" className="btn btn-info m-1 btn-tutorial">
                  <Link to="/support">Suporte Técnico</Link>
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
